import * as React from 'react';

var CharacterCount = function (props) {
    var maxLen = props.maxLen, valueLen = props.valueLen, isSkeleton = props.isSkeleton;
    if (isSkeleton) {
        return React.createElement("span", { "data-testid": "character-count-skeleton" }, "\u00A0");
    }
    if (!maxLen || valueLen === undefined) {
        return React.createElement("span", null, "- characters remaining");
    }
    return (React.createElement("span", { "data-testid": "text-input-character-count" },
        maxLen - valueLen,
        "/",
        maxLen,
        " characters remaining"));
};

export { CharacterCount as C };
